import { Animation, AnimationController } from "@ionic/angular";

const animationCtrl = new AnimationController();

export const getIonPageElement = (element: HTMLElement) => {
  if (element.classList.contains('ion-page')) {
    return element;
  }

  const ionPage = element.querySelector(
    ':scope > .ion-page, :scope > ion-nav, :scope > ion-tabs'
  );
  if (ionPage) {
    return ionPage;
  }
  return element;
};

export const customTabAnimation = (_: HTMLElement, opts: any): Animation => {
  const transition = animationCtrl.create();
  // const enteringEl = opts.enteringEl;
  // const enteringPageEl = getIonPageElement(enteringEl);
  // console.log("el", enteringEl);
  // console.log("el", enteringPageEl);

  // transition
  // .addElement(enteringPageEl)
  // .duration(0)
  // .fill('both')
  // .beforeRemoveClass('ion-page-invisible');

  return transition;
}